// import { env } from '@/shared/config'
// import { Analytics } from '@/shared/lib/analytics'
// import { cookiesAccess } from '@codestreet/analytics'
// import { deviceIdGet } from '@/shared/lib/deviceId'
// import { FacebookAdapter } from '@/shared/lib/facebook'
// import { windowIdGet } from '@/shared/lib/windowId'

// const ANALYTICS_NAME = 'facebook'
// const COOKIES_ACCESS_LEVEL = 'analytics'

// export default defineNuxtPlugin({
//   parallel: true,
//   setup() {
//     const adapter = new FacebookAdapter(
//       () => cookiesAccess.canInit(COOKIES_ACCESS_LEVEL),
//       env.IS_DEV || env.IS_STAGE,
//       windowIdGet(),
//       deviceIdGet(),
//       env.FACEBOOK_PIXEL_ID,
//     )
//     Analytics.clientSet(ANALYTICS_NAME, adapter)
//     Analytics.clientGet(ANALYTICS_NAME)?.init()

//     return {
//       provide: {
//         [ANALYTICS_NAME]: {
//           event: adapter.facebookEvent,
//           eventInit: adapter.eventInit,
//           sendFbcFba: adapter.sendFbcFba,
//         },
//       },
//     }
//   },
// })

import { FacebookAdapter, cookiesAccess, analyticsState } from '@codestreet/analytics'
import { deviceIdGet, windowIdGet  } from '@codestreet/utils'

import { env } from '@/shared/config'

const ANALYTICS_NAME = 'facebook'
const COOKIES_ACCESS_LEVEL = 'analytics'

type ApiResponse = {
  success: boolean
}

const API_REQUEST_PATH = '/app/log-event'

export function appLogEventPost(event: string, data: any = {}) {
  const formData = {
    fb_event: {
      event,
      data,
    },
  }
  return useApiApp<ApiResponse>(API_REQUEST_PATH, 'POST', formData)
}

export default defineNuxtPlugin({
  parallel: true,
  setup() {
    const adapter = new FacebookAdapter(
      () => cookiesAccess.canInit(COOKIES_ACCESS_LEVEL),
      env.IS_DEV || env.IS_STAGE,
      windowIdGet(),
      deviceIdGet(),
      env.FACEBOOK_PIXEL_ID,
      appLogEventPost,
    )
    analyticsState.clientSet(ANALYTICS_NAME, adapter)
    analyticsState.clientGet(ANALYTICS_NAME)?.init()

    return {
      provide: {
        [ANALYTICS_NAME]: {
          event: adapter.facebookEvent,
          eventInit: adapter.eventInit,
        },
      },
    }
  },
})
